import React, { useState, useEffect } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import api from '../../../services/api';

const Step5Apaar = () => {
    const { mockUser, refreshUser } = useOutletContext();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({
        hasApaar: '0' // 0=Select, 1=Yes, 2=No
    });

    // Load Data
    useEffect(() => {
        const init = async () => {
            try {
                const res = await api.get(`/mock-cuet/application-data?mockAppId=${mockUser.id}`);
                if (res.data.success) {
                    const dbData = res.data.data;
                    setFormData({
                        hasApaar: dbData.has_apaar_id === 1 ? '1' : '2'
                    });
                }
            } catch (err) { console.error(err); }
        };
        init();
    }, [mockUser]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (formData.hasApaar === '0') {
            alert("Required Field ?");
            return;
        }

        if (!window.confirm('Are you sure you want to submit ?')) {
            return;
        }

        setLoading(true);

        try {
            const res = await api.post('/mock-cuet/save-step', {
                mockAppId: mockUser.id,
                stepNumber: 5,
                stepData: formData,
                nextStepNumber: 6
            });

            if (res.data.success) {
                refreshUser(6);
                navigate('/services/counselling/dashboard/exam-center');
            }
        } catch (err) {
            alert("Error saving data");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div id="ctl00_ContentPlaceHolder1_pnlApplicationForm">
            <div className="appstatus" style={{ paddingTop: '0px', marginTop: '0px' }}>
                <div id="ctl00_ContentPlaceHolder1_pnlApparYesNo">
                    <div className="container-fluid contentmid" style={{ padding: 0 }}>
                        
                        <h4>अपार आईडी (APAAR ID)</h4>
                        
                        <div className="col-sm-12 form-group text-center">
                        </div>

                        <div className="form-horizontal formLabel">
                            <div className="form-group">
                                <label className="control-label col-sm-4">
                                    Do you have APAAR ID?<br />
                                    क्या आपके पास अपार आईडी है?
                                </label>
                                <div className="col-sm-4">
                                    <select 
                                        name="hasApaar" 
                                        className="form-control" 
                                        value={formData.hasApaar} 
                                        onChange={handleChange}
                                    >
                                        <option value="0">--Select--</option>
                                        <option value="1">Yes</option>
                                        <option value="2">No</option>
                                    </select>
                                    {formData.hasApaar === '0' && (
                                        <span className="ValidatorError" style={{color:'Red', display:'none'}}>Required Field ?</span>
                                    )}
                                </div>
                            </div>

                            <div className="form-group">
                                <div className="col-sm-12 text-center">
                                    <br /><br />
                                    <div style={{display:'inline-block'}}>
                                        {/* Back Button matching previous forms for navigation flow */}
                                        <button 
                                            type="button" 
                                            className="btn btn-warning" 
                                            onClick={() => navigate('/services/counselling/dashboard/identity-details')} 
                                            style={{marginRight:'10px'}}
                                        >
                                            Back
                                        </button>
                                        
                                        <button 
                                            type="submit" 
                                            className="btn btn-primary" 
                                            onClick={handleSubmit} 
                                            disabled={loading}
                                        >
                                            {loading ? 'Saving...' : 'Submit'}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Step5Apaar;